module.exports = __webpack_public_path__ + "static/img/Bachelor_010659.eb92d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010659.jpg
// module id = 204
// module chunks = 0